import { TreatmentType } from '../enums';


export class PriceListCode{
    ID: number;
    Name: string;
    Active: boolean;
    Code: string;
    Price?: number;
    CategoryID: number;
    Duration: number;
    DepartmentID: number;
    PriceListRefID: number;
    PriceListID?: number;
    SubCodeCount?: number;
    SubCodeID?: number;
    TypeID: TreatmentType;
    Description: string;
    FinalPrice?: number;
    Selected?: boolean;
    ParentTypeID?: TreatmentType;
    TaxPercent : number;
    LabelColorID? : number;

    constructor(obj?: any){
        this.ID = obj && obj.ID || null;
        this.Name = obj && obj.Name || null;
        this.Active = obj && obj.Active || null;
        this.Code = obj && obj.Code || null;
        this.Price = obj && obj.Price || null;
        this.CategoryID = obj && obj.CategoryID || null;
        this.Duration = obj && obj.Duration || 0;
        this.DepartmentID = obj && obj.DepartmentID || null;
        this.PriceListRefID = obj && obj.PriceListRefID || null;
        this.PriceListID = obj && obj.PriceListID || null;
        this.SubCodeCount = obj && obj.SubCodeCount || null;
        this.SubCodeID = obj && obj.SubCodeID || null;
        this.TypeID = obj && obj.TypeID || null;
        this.Description = obj && obj.Description || null;
        this.FinalPrice = obj && obj.FinalPrice || null;
        this.ParentTypeID = obj && obj.ParentTypeID || null;
        this.TaxPercent = obj && obj.TaxPercent || 0;
        this.LabelColorID = obj && obj.LabelColorID || 0;

        
        this.Selected = obj && obj.Selected || false;
    }

    
}